import React from 'react'

import {Loader} from './Loader'

export function MainLoader() {
  return <Loader height="60vh" />
}
